import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { rowLabel, progressValue } from "./userUtils";

// ===== LEARNING PROGRESS BAR CHART DATA =====
function buildProgressChartData(progress) {
  let courses = [];
  if (!progress) return courses;
  if (Array.isArray(progress)) courses = progress;
  else if (Array.isArray(progress.courses)) courses = progress.courses;
  else if (Array.isArray(progress.data)) courses = progress.data;
  else if (Array.isArray(progress.progress)) courses = progress.progress;

  const items = courses
    .map((c) => ({
      name: rowLabel(typeof c === "object" ? c : { title: c }),
      progress: progressValue(typeof c === "object" ? c : {}),
    }))
    .filter((c) => c.name && c.name !== "N/A");
  return items.slice(0, 12);
}

const ProgressBarChart = ({ progress, loading, error }) => {
  const data = buildProgressChartData(progress);

  if (loading)
    return (
      <div style={{ color: "#94a3b8", fontSize: "13px", padding: "10px 0" }}>
        Loading progress…
      </div>
    );
  if (error)
    return (
      <div style={{ color: "#dc2626", fontSize: "13px", padding: "10px 0" }}>
        {error}
      </div>
    );
  if (!data.length)
    return (
      <div style={{ color: "#94a3b8", fontSize: "13px", padding: "10px 0" }}>
        No learning progress data available.
      </div>
    );

  return (
    <div style={{ height: "280px", width: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" fontSize={10} interval={0} angle={-15} height={40} />
          <YAxis domain={[0, 100]} />
          <Tooltip />
          <Bar dataKey="progress" fill="#2563eb" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
          marginTop: "8px",
          textAlign: "right",
        }}
      >
        Progress percentage per course
      </div>
    </div>
  );
};

export default ProgressBarChart;